import {
  HIDE_COHORT_REPORTS_LIST_LOADER,
  HIDE_COHORT_REPORTS_OPTIONS_LOADER,
  HIDE_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION_LOADER,
  SET_COHORT_REPORTS_COHORT_SETUP,
  SET_COHORT_REPORTS_LIST,
  SET_COHORT_REPORTS_OPTIONS,
  SET_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION,
  SET_COHORT_REPORTS_PROFILE,
  SET_COHORT_REPORTS_SHOW_FILTER, SET_COHORT_REPORTS_TEMPLATE, SET_COHORT_REPORTS_TEMPLATES,
  SET_ERROR_COHORT_REPORTS_PROFILE, SET_INIT_COHORT_REPORTS_STATE,
  SHOW_COHORT_REPORTS_LIST_LOADER,
  SHOW_COHORT_REPORTS_OPTIONS_LOADER,
  SHOW_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION_LOADER
} from "./actionTypes"
import {
  COHORT_TYPE_OPTIONS,
  DATA_FORMAT_OPTIONS,
  DATE_OPTIONS,
  TREND_TYPE_OPTIONS
} from "../../pages/Reporting/CohortReports"
import qs from "querystring"
import { getInitialDate } from "../../helpers/utils"

const INIT_STATE = {
  data: [],
  // data: {
  //   count: 0,
  //   next: null,
  //   previous: null,
  //   page: 1,
  //   sizePerPage: 10,
  //   results: []
  // },
  profileData: [],
  isError: false,
  loading: true,
  // success: null,
  error: null,
  isLoaderOptions: true,
  options: {
    params: [],
    events: [],
  },
  templates: [],
  template: undefined,
  show_filter: {
    v1th: undefined, // 1th show select
    v2th: undefined, // 2th show select
    o2th: [] // options for 2th show select
  },
  params_for_fragmentation: [],
  isLoaderParamsForFragmentation: true,
  cohort_setup: {
    group_by: [undefined], // must be min 1 element
    filter_by: [],
    cohort_type: COHORT_TYPE_OPTIONS[0],
    trend_type: TREND_TYPE_OPTIONS[0],
    days: DATE_OPTIONS[0],
    users: undefined,
    start_date: getInitialDate('start_date', new Date(new Date().setDate(1))),
    end_date: getInitialDate('end_date'),
    type: DATA_FORMAT_OPTIONS[0].value
  }

}

const CohortReportList = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SET_COHORT_REPORTS_TEMPLATE:
      return {
        ...state,
        template: action.payload
      }
    case SET_COHORT_REPORTS_TEMPLATES:
      return {
        ...state,
        templates: action.payload
      }
    case SET_COHORT_REPORTS_LIST:
      return {
        ...state,
        data: action.payload
      }
    case SHOW_COHORT_REPORTS_LIST_LOADER:
      return {
        ...state,
        loading: true
      }
    case HIDE_COHORT_REPORTS_LIST_LOADER:
      return {
        ...state,
        loading: false
      }
    case SET_COHORT_REPORTS_PROFILE:
      return {
        ...state,
        profileData: action.payload
      }
    case SET_ERROR_COHORT_REPORTS_PROFILE:
      return {
        ...state,
        isError: action.payload
      }
    case SHOW_COHORT_REPORTS_OPTIONS_LOADER:
      return {
        ...state,
        isLoaderOptions: true
      }
    case HIDE_COHORT_REPORTS_OPTIONS_LOADER:
      return {
        ...state,
        isLoaderOptions: false
      }
    case SET_COHORT_REPORTS_OPTIONS:
      return {
        ...state,
        options: action.payload
      }
    case SHOW_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION_LOADER:
      return {
        ...state,
        isLoaderParamsForFragmentation: true
      }
    case HIDE_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION_LOADER:
      return {
        ...state,
        isLoaderParamsForFragmentation: false
      }
    case SET_COHORT_REPORTS_PARAMS_FOR_FRAGMENTATION:
      return {
        ...state,
        params_for_fragmentation: action.payload
      }
    case SET_COHORT_REPORTS_SHOW_FILTER:
      return {
        ...state,
        show_filter: {
          ...state.show_filter,
          ...action.payload
        }
      }
    case SET_COHORT_REPORTS_COHORT_SETUP:
      return {
        ...state,
        cohort_setup: {
          ...state.cohort_setup,
          ...action.payload
        }
      }
    case SET_INIT_COHORT_REPORTS_STATE:
      return {
        ...INIT_STATE
      }
    default:
      return state
  }
}

export default CohortReportList
